import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HealthPassportPage = lazy(() => import("./HealthPassportPage"));

const HealthPassportPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HealthPassportPage />
    </Suspense>
  );
};

export default HealthPassportPageLazy;
